import { render, staticRenderFns } from "./paysolus-notice.vue?vue&type=template&id=378df77a&scoped=true&"
import script from "./paysolus-notice.vue?vue&type=script&lang=js&"
export * from "./paysolus-notice.vue?vue&type=script&lang=js&"
import style0 from "./paysolus-notice.vue?vue&type=style&index=0&id=378df77a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378df77a",
  null
  
)

export default component.exports